require('./bootstrap');

// Import Swiper bundle
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

// Make Swiper globally available BEFORE DOMContentLoaded
window.Swiper = Swiper;
